import { environment } from '../../environments/environment';
export enum DominioOrigen {
    Iconstruye = 1,
    Agilice = 2,
    Redmat = 3
}

export const DominioUrls: { [key in DominioOrigen]: string } = {
    [DominioOrigen.Iconstruye]:environment.production ?'iconstruye.com':'iconstruye.cl',
    [DominioOrigen.Agilice]: environment.production ?'agilice.com':'agilice.cl',
    [DominioOrigen.Redmat]: environment.production ?'redmat.com':'iconstruye.cl'
  };
